import { Button, EButtonColor } from '@web_opxp/components';
import { renderMultilineLoca, useTranslation } from '@web_opxp/features';
import { useEffect, useState } from 'react';
import CloseButton from '../CloseButton/CloseButton';
import HintPopup from '../HintPopup/HintPopup';
import './MoodTracker.scss';
import SmileySlider from './SmileySlider';

export interface IMoodtrackerProps {
  visible: boolean;
  onMoodTracking: (result: number) => void;
}

const MoodTracker = ({ visible, onMoodTracking }: IMoodtrackerProps) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(visible);
  const [mood, setMood] = useState(3);
  const minMood = 1;
  const maxMood = 5;

  const hint = renderMultilineLoca(t('Dashboard.MoodTracker.HintLines'));

  const handleSave = () => {
    onMoodTracking(mood);
    handleClose();
  };

  const handleClose = () => {
    localStorage.setItem('mood-tracker-timestamp', Date.now().toString());
    setIsVisible(false);
  };

  useEffect(() => {
    if (!visible) {
      return;
    }

    // Don't change the following to ?? because item can be empty string
    const moodTrackerTimestamp = parseInt(localStorage.getItem('mood-tracker-timestamp') || '0');
    const lastTimestamp = new Date(moodTrackerTimestamp).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);

    setIsVisible(today !== lastTimestamp);
  }, [visible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="mood-tracker">
      <div className="mood-tracker-header">
        <h2 className="mood-tracker-title">{t('Dashboard.MoodTracker.Title')}</h2>
        <HintPopup iconSize={24}>{hint}</HintPopup>
        <CloseButton onClick={handleClose} />
      </div>
      <div className="mood-tracker-body">
        <SmileySlider value={mood} min={minMood} max={maxMood} onChange={setMood} />
        <Button
          className="submit-btn mood-tracker-button"
          label={t('Dashboard.MoodTracker.Done')}
          color={EButtonColor.blue}
          onClick={handleSave}
        />
      </div>
    </div>
  );
};

export default MoodTracker;
